import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import App from './App.vue';
import router from './router';

import './plugins/bootstrap-vue';
import './plugins/font-awesome';
import './plugins/vee-validate';
import './plugins/vue-axios';
import './plugins/vue-sweetalert';
import './plugins/vue-select';

// import './css/theme.css';
// import './css/theme_darkly.css';
// import './css/bootstrap.min.css';
import './scss/style.scss';
import './css/style.css';

Vue.config.productionTip = false;

let vue = new Vue({
    router,
    render: h => h(App)
}).$mount('#app');

export default vue;